export default __webpack_public_path__ + "static/media/icon-512x512.0be1da80.png";